// extracted by mini-css-extract-plugin
module.exports = {"context-item":"context-item___2E-xq","name":"name___2dnww","cropper":"cropper___1nDn6","is-archived":"is-archived___37Nh4"};